import MultiStepForm from "../components/MultiStepForm/multiStepForm";
import Navbar from "../components/navigation/navBar";
import {useServicePopup} from "../components/services/ServicePopupContext";


const Contact = () => {
    const { openPopup } = useServicePopup();

    const handleServiceClick = (serviceId) => {
        openPopup(parseInt(serviceId));
        return false;
    };

    return (
        <div>
            <Navbar
                home={'/'}
                s1={'1'}
                s2={'2'}
                s3={'3'}
                s4={'4'}
                s5={'5'}
                s6={'6'}
                about={'/qui-sommes-nous'}
                articles={'/articles'}
                location={'/ou-nous-rencontrer'}
                contact={'/contact'}
                facebook={'#'}
                instagram={'#'}
                google={'#'}
                phone={'#'}
                onServiceClick={handleServiceClick}
            />
            <MultiStepForm/>
        </div>
    );
};

export default Contact;
